import React from 'react';
import { TriageSettingsKeys, } from '@corti/lib/coreApiService';
import { ToggleSwitch } from './ToggleSwitch';
export const TriageSettings = ({ triageSettings, onUpdateTriageSettings }) => {
    const handleFieldChange = (value) => {
        onUpdateTriageSettings(value);
    };
    return (React.createElement(ToggleSwitch, { label: TriageSettingsKeys.automaticProgressToNextStep, checked: triageSettings[TriageSettingsKeys.automaticProgressToNextStep], onChange: (_event, checked) => handleFieldChange({ [TriageSettingsKeys.automaticProgressToNextStep]: checked }) }));
};
